export const initialBillingSchedule = {
  day31: false,
  day31BillingCode: "",
  day91: false,
  day91BillingCode: "",
  custom: {
    days: 0,
    enabled: false,
    customBillingCode: "",
  },
};

const initialProfile = {
  account: "",
  sub_account: "",
  serial_number: "",
  last_send: "",
  next_send: "",
  nextSendDays: "",
  nextBillingDateChanged: false,
  last_bill_date: "",
  next_bill_date: "",
  total_sends: "",
  dob: "",
  firstName: "",
  gender: "",
  genderIdentity: "",
  marital_status: "",
  ssn: "",
  sexAssignedAtBirth: "",
  lastName: "",
  middleInitial: "",
  mrn: "",
  name: "",
  manufacturer: "",
  physicians: [],
  active: false,
  hospital: "",
  rpm_devices: {
    isHl7Exist: false,
    imei: "",
    active: false,
    last_send: "",
  },
  hfToClinic: false,
  // regularToClinic: false,
  referringProviderId: "",
  need_magnet_during_procedures: null,
  laao_device: null,
  idtf: null,
  preferredLanguage: "",
};

export const initialInformation = {
  phone1: "",
  phone2: "",
  email: "",
  street1: "",
  street2: "",
  city: "",
  state: "",
  zip: "",
};

export const initialPatientHistoryInformation = {
  diagnosis: "",
  strokeHistory: "",
  anticoag_information: null,
};

export const initialDeviceInformation = {
  modelName: "",
  modelNumber: "",
  mriCompatible: false,
  prevDevice: "",
  lead1: "",
  lead2: "",
  lead3: "",
  alertDevice: false,
  alertDeviceText: "",
  rpm_devices: [],
  implanting_physicians: [],
  is_monitor_disconnected: false,
  monitor_disconnected_at: null,
  monitor_disconnected_status: "",
  previous_monitor_disconnected_at: null,
  monitor_disconnected_history: [],
};

export const initialInsurance = {
  name: "",
  patientId: "",
  patientGroup: "",
  plan: "",
  patientRelation: "",
  effectiveDate: "",
  authorization_code: "",
  treatment_start: "",
  treatment_end: "",
  street: "",
  city: "",
  state: "",
  zip: "",
  payor_id: "",
  active: false,
  insured: {
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    street: "",
    city: "",
    state: "",
    zip: "",
  },
};

export const initialGuarantor = {
  mrn: "",
  first_name: "",
  middle_name: "",
  last_name: "",
  patient_relation: "",
  street: "",
  city: "",
  state: "",
  zip: "",
  email: "",
  dob: "",
  gender: "",
  type: "",
  phone1: "",
  phone2: "",
};

const initialPatientAlertInformation = {
  alertPatient: false,
  alertPatientText: "",
};

const patientCommunicationAndNotes = {
  updatedNotes: "",
};

export const initialPatientTask = {
  _id: "",
  status: "To Do",
  description: "",
  account: "",
  notes: "",
};

export const transmissionPatientModalState = {
  patientAccount: "",
  patientSerialNumber: "",
  patientTab: "reports",
  profileTab: "generalInformation",
  scrollToNotesSection: false,
  hasAccessToProfileTabs: false,
  patientId: "",
  profile: initialProfile,
  originalProfile: initialProfile,
  billingSchedule: { ...initialBillingSchedule },
  originalBillingSchedule: { ...initialBillingSchedule },
  information: initialInformation,
  originalInformation: initialInformation,
  patientHistoryInformation: initialPatientHistoryInformation,
  patientOriginalHistoryInformation: initialPatientHistoryInformation,
  deviceInformation: initialDeviceInformation,
  originalDeviceInformation: initialDeviceInformation,
  originalInsurance: initialInsurance,
  originalSecondaryInsurance: initialInsurance,
  guarantor: initialGuarantor,
  originalTertiaryInsurance: initialInsurance,
  patientAlertInformation: { ...initialPatientAlertInformation },
  originalPatientAlertInformation: { ...initialPatientAlertInformation },
  patientReports: [],
  originalAlertBanner: "",
  alertBanner: "",
  isSubmitting: false,
  isBillingEqual: true,
  currentPatientTask: initialPatientTask,
  originalPatientTask: initialPatientTask,
  isPatientTaskModal: false,
  patientTaskAction: "Add",
  fetchPatientTasks: false,
  isDataPointUpdated: false,
  fetchPatientReports: false,
  isDeactivate: false,
  deactivateFrom: "",
  benchmarkInsurances: {
    primaryInsurance: initialInsurance,
    secondaryInsurance: initialInsurance,
    tertiaryInsurance: initialInsurance,
  },
  phoneOptOutInformation: {
    primaryNumberOptOut: false,
    secondaryNumberOptOut: false,
    emergencyPhoneOptOut: false,
  },
  patientCommunicationAndNotes: { ...patientCommunicationAndNotes },
};
